module.exports = __webpack_public_path__ + "static/media/arrow_open.cee6060d.svg";